import { styled } from 'styled-components';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
  border-radius: 16px;
  color: ${({ theme }) => theme.colors.defaultWhite};
  font-family: 'Hanken Grotesk', sans-serif;
  max-width: 300px;
  height: 136px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: ${({ theme }) => theme.breakpoint.desktop}) {
    max-width: 100%;
    height: 117px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}) {
    height: 136px;
  }

  ${({ $variant, theme }) =>
    $variant === 'testimonial' &&
    `
    background: linear-gradient(135deg, ${theme.colors.secondary} 0%,rgb(68, 167, 253) 100%);
    text-align: center;
    box-shadow: 0 25px 55px -25px rgba(30, 148, 252, 0.7);

    @media (max-width: ${theme.breakpoint.desktop}) {
      height: 117px;
    }

    @media (max-width: ${theme.breakpoint.mobile}) {
      height: auto;
      min-height: 136px;
    }
  `}

  ${({ $variant, theme }) =>
    $variant === 'tip' &&
    `
    background-color: transparent;
    perspective: 1000px;
    padding: 0;
    display: block;
    
    @media (min-width: ${theme.breakpoint.desktop}) {
      &:hover .flip-inner {
        transform: rotateY(180deg);
      }
    }
    
    @media (max-width: 1023px) {
      cursor: pointer;
      
      .flip-inner.flipped {
        transform: rotateY(180deg);
      }
    }

  `}
`;

export const FlipCardInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
`;

export const FlipCardFront = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
  border-radius: 16px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.defaultWhite};
  color: ${({ theme }) => theme.colors.gray600};
  box-shadow: 0 10px 30px -10px rgba(19, 41, 61, 0.2);
  border: 1px solid rgba(19, 41, 61, 0.06);
  max-width: 300px;
  height: 136px;

  @media (max-width: ${({ theme }) => theme.breakpoint.desktop}) {
    max-width: 100%;
    height: 117px;
    flex-direction: row;
    align-items: center;
    gap: 24px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}) {
    height: 136px;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
  }
`;

export const FlipCardBack = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transform: rotateY(180deg);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 16px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.secondary600};
  color: ${({ theme }) => theme.colors.defaultWhite};
  box-shadow: 0 10px 30px -10px rgba(19, 41, 61, 0.2);
  max-width: 300px;
  height: 136px;

  @media (max-width: ${({ theme }) => theme.breakpoint.desktop}) {
    max-width: 100%;
    height: 100%;
    min-height: 117px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}) {
    min-height: 136px;
  }
`;

export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CardHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CardInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardImageWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
`;

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CardDescription = styled.p`
  font-weight: 300;
  font-size: 14px;
  line-height: 1.3;
  text-align: left;
  margin: 0;
`;

export const CardName = styled.h3`
  font-weight: 500;
  font-size: 16px;
  line-height: 1.4;
  margin: 0;
  text-align: left;
`;

export const CardRole = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 1.3;
  text-align: left;
  margin: 0;
`;

export const CardIconsWrapper = styled.div`
  display: flex;
  justify-content: start;
`;

export const CardIcon = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
`;

export const CardTitle = styled.h4`
  font-weight: 400;
  font-size: 16px;
  text-align: left;
  margin: 0;
  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}) {
    text-align: center;
  }
`;
